// mutations
const SET_TEMPLANGUAGE = (state, payload) => {
  state.temp_language = payload;
};
const SET_USERID = (state, payload) => {
  state.user_id = payload;
};
const SET_IDLANGUAGE = (state, payload) => {
  state.id_language = payload;
};
const SET_RESLANGUAGEBYID = (state, payload) => {
  state.res_languageByID = payload;
};
export default {
  SET_RESLANGUAGEBYID,
  SET_USERID,
  SET_TEMPLANGUAGE,
  SET_IDLANGUAGE
};
